import { combineReducers } from '@reduxjs/toolkit'
import { entryTypesReducer } from 'apps/formsCreationKit/store/reducers/types/entryTypes'
import { conditionTypesReducer } from 'apps/formsCreationKit/store/reducers/types/conditionTypes'
import { operationTypesReducer } from 'apps/formsCreationKit/store/reducers/types/operationTypes'
import { fontTypesReducer } from './fontTypes'

export const typesReducers = combineReducers({
  entryTypes: entryTypesReducer,
  conditionTypes: conditionTypesReducer,
  operationTypes: operationTypesReducer,
  fontTypes: fontTypesReducer,
})
